module.exports = __webpack_public_path__ + "static/ad43497c57e213013ec9656ef0e3fa10.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon.ico
// module id = 1159
// module chunks = 0